import { render } from "./GeneralModal.vue?vue&type=template&id=4ad225ed&scoped=true"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"

import "./GeneralModal.vue?vue&type=style&index=0&id=4ad225ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad225ed"]])

export default __exports__